<template>
	<div class="wrapper">
		<div class="top">
			<img src="../assets/avatar.png" alt="" />
			<div class="desc">
				<div class="left">
					<span class="title">Qunbi Zhuge （诸葛群碧）</span>
					<p>Professor</p>
					<!-- <p>IEEE Senior Member</p> -->
					<p>Department of Electronic Engineering, Shanghai Jiao Tong University</p>
				</div>
				<div class="right">
					<p>
						<i class="el-icon-location"></i>
						Office: SEIEE Building 5-519
					</p>
					<!-- <p>
						<i class="el-icon-phone"></i>
						Tel: +86-21-34205419
					</p> -->
					<p>
						<i class="el-icon-message"></i>
						Email: qunbi.zhuge@sjtu.edu.cn
					</p>
				</div>
				<!-- <div class="google">Google Scholar</div> -->
			</div>
		</div>
		<div class="cont">
			<div class="left">
				<div class="experience card">
					<!-- <i class="el-icon-collection-tag"></i> -->
					<div class="title">Experience</div>
					<div class="titleLine"></div>
					<ul>
						<li v-for="(item, idx) in experiences" :key="idx">
							<span>{{ item }}</span>
						</li>
						<li>
							<a
								style="
									text-decoration: underline;
									color: #1c89f5;
								"
								target="_blank"
								href="https://scholar.google.com/citations?hl=zh-CN&user=R5isVogAAAAJ"
								>Google Scholar Profile</a
							>
						</li>
					</ul>
				</div>
				<div class="research card experience">
					<!-- <i class="el-icon-collection-tag"></i> -->
					<div class="title">Research Areas</div>
					<div class="titleLine"></div>
					<ul>
						<li v-for="(item, idx) in research" :key="idx">
							<span>{{ item }}</span>
						</li>
					</ul>
				</div>
			</div>
			<div class="right">
				<div class="newsList">
					<!-- <div class="title">News</div>
					<div class="titleLine"></div> -->
					<a
						class="news"
						v-for="(item, idx) in news"
						:key="idx"
						:href="item.noLink ? 'javascript:void(0)' : item.link"
						:target="!item.noLink && '_blank'"
					>
						<div>
							<span class="time">{{ item.year }}</span>
							<span class="title">{{ item.title }}</span>
						</div>
						<i class="el-icon-arrow-right"></i>
					</a>
				</div>
				<div class="more-wrapper">
					<div class="more" @click="$router.push('/more')">more</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>


export default {
	data() {
		return {
			research: [
				'Ultra-wideband optical communication',
				'Optical network intelligence',
				'Optical-wireless convergence',
				'Data center interconnect and network',
			],
			experiences: [
				'Professor at Shanghai Jiao Tong University (2025~)',
				'Associate Professor at Shanghai Jiao Tong University (2018-2025)',
				'Ph.D., McGill University (2015); Bachelor, Zhejiang University (2009)',
				'IEEE Senior Member (2020); OSA Senior Member (2019)',
				'MIT Technology Review “Innovators Under 35” China (2020)',
				'Chair of OFC S4 Sub-committee (2019)',
				'Chair of OSA Optical Communications Group (2019-2021)',
				'Chair of Track Optical Transmission Systems, Subsystems and Technologies, Asia Communications and Photonics Conference (ACP) (2023)',
				'Associate Editor of Optics Express (2017-2023), Electronics Letters (2018-2021), IEEE Access (2019-2022)',
				'Executive Editor of Springer Nature Optical and Quantum Electronics (2024~)',
				'Editorial Board Member of Springer Nature Optical and Quantum Electronics (2022-2023)',
				// 'Google Scholar Profile',
			],
			news: [
				// 此处限制最多六条，每次更新一条则对应删去最后一条，并将新加入的复制到More.vue中
				{ year: 2025, title: 'Xiaomin Liu Received IEEE Photonics Society Graduate Student Fellowships (1 of 10, Worldwide)', link: 'https://mp.weixin.qq.com/s/kQbO9GbWlIYZPnsoq6VaJA'},
				{ year: 2024, title: 'Xiaomin Liu Named Corning Women Scholar in Optical Fiber Communications Conference (OFC)', link: 'https://mp.weixin.qq.com/s/l21XwOTnEnJeExDjfxXsww'},
				{ year: 2023, title: 'Mengfan Fu and Xiaomin Liu Received International Society for Optics and Photonics (SPIE) Optics & Photonics Education Scholarship', link: 'https://news.sjtu.edu.cn/jdyw/20230628/185321.html'},
				{ year: 2022, title: 'Xi Chen Named Best Student Paper Competition Winner in International Conference on Optical Communications and Networks (ICOCN)', link: 'https://news.sjtu.edu.cn/jdyw/20221106/176005.html'},
				{ year: 2022, title: 'Yicheng Xu Named Excellent Bachelor Thesis (Top 1%) in Shanghai Jiaotong University (SJTU)', link: 'https://www.seiee.sjtu.edu.cn/index_news/1223.html'},
				{ year: 2021, title: 'Xiaomin Liu Named Best Student Paper Competition Winner in Asia Communications and Photonics (ACP) Conference', link: 'https://mp.weixin.qq.com/s?__biz=MzA3Nzg4NzM4Mw==&mid=2460586346&idx=1&sn=d8cd262cf1cdaef399508fc7d3b41e07&chksm=88161392bf619a8459416f6655ef31b5b06a6ab81c0a9b2a8c5b4677d38625894fce3cdc294d&token=787713613&lang=zh_CN#rd'},
				{ year: 2021, title: 'Qizhi Qiu Named OSA Student Paper Competition Winner in Advanced Photonics Congress (APC)', link: 'https://mp.weixin.qq.com/s/Zml5NyDUCLsbEdyLHiJHCg' },
				{ year: 2020, title: 'Qunbi Zhuge Named “Innovators Under 35” of MIT Technology Review in China', link: 'https://www.innovatorsunder35.com/the-list/2020/china/telecommunications' },

			]
		}
	}

}
</script>

<style scoped lang="scss">
.top {
	padding: 20px;
	border-radius: 10px;
	// height: 300px;
	background: #fafafa;
	display: flex;
	img {
		height: 280px;
		width: 260px;
		border-radius: 20px;
		margin-right: 110px;
	}
	.desc {
		color: #04111f;
		font-size: 20px;
		font-family: 'Times New Roman', Times, serif;
		font-weight: 500;
		// display: flex;

		.title {
			font-size: 38px;
			font-weight: 600;
			font-family: 'Times New Roman', Times, serif;
			display: block;
			margin-bottom: 35px;
		}
		.left {
			margin-bottom: 45px;
		}
		.right {
			color: #10375e;
		}
		p {
			margin-bottom: 10px;
			i {
				margin-right: 10px;
			}
		}
		.google {
			color: #004098;
			background: rgba(16, 55, 94, 0.04);
			border-radius: 4px;
			width: 124px;
			height: 32px;
			text-align: center;
			line-height: 32px;
			text-decoration: underline;
			cursor: pointer;
			margin-top: 30px;
		}
	}
}
.cont {
	margin-top: 20px;
	.card {
		border: 1px solid #eeeeee;
		border-radius: 10px;
		position: relative;
		padding: 40px;
		.el-icon-collection-tag {
			position: absolute;
			color: #10375e;
			top: -1px;
			right: 20px;
		}
		.title {
			font-size: 22px;
			font-family: 'Times New Roman', Times, serif;
			color: #04111f;
			font-weight: 650;
			display: block;
			position: relative;
		}
		.titleLine {
			height: 2px;
			width: 38px;
			background: #10375e;
			margin-top: 5px;
			margin-bottom: 20px;
		}
	}
	display: flex;
	.left,
	.right {
		flex: 1;
	}
	.left {
		margin-right: 20px;
		.experience {
			margin-bottom: 20px;
			> ul {
				margin-left: 15px;
				> li {
					color: #04111f;
					font-size: 18px;
					font-family: 'Times New Roman', Times, serif;
					font-weight: 500;
					line-height: 28px;
					margin-top: 10px;
					.time {
						font-weight: normal;
					}
				}
			}
		}
		.research {
			p {
				// margin-top: 40px;
				font-size: 18px;
				font-family: 'Times New Roman', Times, serif;
				line-height: 28px;
				color: #04111f;
			}
		}
	}
	.right {
		.newsList {
			.news {
				display: flex;
				border: 1px solid #eeeeee;
				border-radius: 10px;
				margin-bottom: 20px;
				padding: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				> div {
					display: flex;
					flex-direction: column;
					cursor: pointer;
					&:hover {
						opacity: 0.7;
					}
					.time {
						color: #91a3b8;
						font-size: 16px;
						font-family: 'Times New Roman', Times, serif;
						display: block;
						margin-bottom: 10px;
					}
					.title {
						color: #04111f;
						font-size: 18px;
						font-family: 'Times New Roman', Times, serif;
					}
				}
			}
		}
		.more-wrapper {
			width: 100%;
		}
		.more {
			width: 144px;
			height: 40px;
			background: #ffffff;
			border: 1px solid #1c89f5;
			color: #1c89f5;
			text-align: center;
			line-height: 40px;
			cursor: pointer;
			margin: 0 auto;
			font-family: 'Times New Roman', Times, serif;
			font-size: 22px;
			font-weight: 550;
		}
	}
}
</style>
